import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CustomPagination from "../Utility/CustomPagination";
import { ImageSkeleton, LineSkeleton } from "../Utility/Skeletons";

function CompletedExperience() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 5; // per page

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("authToken");

        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE}/user/bookings/completed?page=${currentPage}&per_page=${limit}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const resData = response.data?.data;
        setBookings(resData?.data || []);
        setTotalPages(resData?.last_page || 1); // ✅ use last_page
      } catch (error) {
        console.error("Error fetching completed bookings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, [currentPage]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
 
  }, [currentPage]);

  const formatTo12Hour = (timeString) => {
  if (!timeString) return "";
  const [hours, minutes, seconds] = timeString.split(":");
  const date = new Date();
  date.setHours(hours, minutes, seconds);
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
};


  return (
    <>
      <div className="dashboardpgs">
        <div className="ds_listsng">
          {loading ? (
            Array.from({ length: limit }).map((_, index) => (
              <div key={index} className="col-lg-4 col-sm-4">
                <ImageSkeleton height="200px" />
                <LineSkeleton width="60%" />
                <LineSkeleton width="40%" />
              </div>
            ))
          ) : bookings.length > 0 ? (
            <>
              {bookings.map((booking, index) => (
                <div className="main_listst" key={index}>
                  <div className="tp_area_cnt">
                    <div className="undr_litst">
                      <h6>{booking.experience_title}</h6>
                    </div>
                    <div className="btm_tx">
                      <p>
                        Booking ID : <strong>{booking.booking_id}</strong>
                      </p>
                    </div>
                  </div>
                  <div className="main_bothssse">
                    <div className="btm_txund">
                      <p>
                        <span className="dtss">Organised By </span> Experience
                        Slot
                      </p>
                      <h6>
                        <span className="dtss">
                          {booking.host_first_name} {booking.host_last_name}
                        </span>{" "}
                        {/* {booking.booking_date}, {booking.booking_from_time} -{" "}
                        {booking.booking_to_time} */}
                        {booking.booking_date},{" "}
{formatTo12Hour(booking.booking_from_time)} - {formatTo12Hour(booking.booking_to_time)}

                      </h6>
                    </div>
                    <div className="viw_detlss">
                      <Link
                        to={`/user-experience-detail/${booking.booking_id}`}
                        className="btnnss"
                      >
                        View Detail
                      </Link>
                    </div>
                  </div>
                </div>
              ))}

             
              <CustomPagination
                currentPage={currentPage}
                lastPage={totalPages}
                onPageChange={handlePageChange}
              />
            </>
          ) : (
            <div className="tlt_area text-center">
              <h3>Looks empty, you’ve no completed bookings !</h3>
              <Link to={"/"} className="btnnss">
                Explore Experiences
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default CompletedExperience;
